import React, { FunctionComponent } from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { moderateScale } from 'react-native-size-matters';
import { Button, ButtonTypes} from '../../../components';
import Theme from '../../../theme';
import { defaultScale } from '../../../utils';

interface IProps {
  label: string;
  primaryAction?: () => void;
  secondaryAction?: () => void;
}

export const MainActionButton: FunctionComponent<IProps> = ({ primaryAction, secondaryAction, label }) => {
  return (
    <TouchableOpacity style={styles.container}>
      <View style={styles.buttonsContainer}>
        {secondaryAction && <Button
          title={label}
          onPress={secondaryAction}
          fontColor={Theme.PRIMARY}
          buttonType={ButtonTypes.OUTLINE}
          containerStyle={styles.buttonContainer}
        />}
        {primaryAction && <Button
          title={label}
          onPress={primaryAction}
          fontColor={Theme.WHITE}
          buttonType={ButtonTypes.NORMAL}
          containerStyle={styles.buttonContainer}
        />}
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 9,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonText: {
    ...Theme.textStyle.bodyCopyBold,
    color: Theme.WHITE,
    textAlign: 'center',
  },
  buttonsContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    paddingTop: defaultScale(10),
  },
  buttonContainer: {
    flex: 1,
    margin: defaultScale(3),
  },
});
